var WellKnownEnum;
(function(WellKnownEnum2) {
  WellKnownEnum2["ALSO_KNOWN_AS"] = "alsoKnownAs";
  WellKnownEnum2["ASSERTION_METHOD"] = "assertionMethod";
  WellKnownEnum2["AUTHENTICATION"] = "authentication";
  WellKnownEnum2["CAPABILITY_DELEGATION"] = "capabilityDelegation";
  WellKnownEnum2["CAPABILITY_INVOCATION"] = "capabilityInvocation";
  WellKnownEnum2["CONTROLLER"] = "controller";
  WellKnownEnum2["KEY_AGRREEMENT"] = "keyAgreement";
  WellKnownEnum2["SERVICE"] = "service";
  WellKnownEnum2["VERIFICATION_METHOD"] = "verificationMethod";
})(WellKnownEnum || (WellKnownEnum = {}));
const WellKnownAttribute = [
  "authentication",
  "assertionMethod",
  "capabilityInvocation",
  "capabilityDelegation"
];

export { WellKnownAttribute, WellKnownEnum };
